export const COLOR_MAIN = "#00587C"
export const COLOR_MAIN_DARK = "#00384F"
export const COLOR_MAIN_LIGHT = "#0092CE"
export const COLOR_BLACK = "#000000"
export const COLOR_DARK = "#222222"
export const COLOR_WHITE = "#FFFFFF"
